import { gql } from '@apollo/client';

import baseFields from '../base';
import FILES from './files';

const DOCUMENTS_FRAGMENT = gql`
  ${FILES}
  fragment DocumentsFragment on Document {
    ${baseFields}
    type
    details
    files {
      ...Files
    }
  }
`;

export default DOCUMENTS_FRAGMENT;
